"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Container = _interopRequireDefault(require("../Container"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _RadioButton = _interopRequireDefault(require("../RadioButton"));

var _Text = _interopRequireDefault(require("../Text"));

var _Tag = _interopRequireDefault(require("../Tag"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _CheckboxCard = _interopRequireDefault(require("./CheckboxCard.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CheckboxWrapper = _styledComponents.default.div.withConfig({
  displayName: "CheckboxCard__CheckboxWrapper",
  componentId: "sc-5qmi0b-0"
})(function (_ref) {
  var theme = _ref.theme,
      removePaddingButtom = _ref.removePaddingButtom;
  return "\n    padding: ".concat(theme.space.normal, ";\n\n    ").concat(removePaddingButtom ? 'padding-bottom: 0' : '', "\n  ");
});

var OptionsListWrapper = _styledComponents.default.ul.withConfig({
  displayName: "CheckboxCard__OptionsListWrapper",
  componentId: "sc-5qmi0b-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      isAccordion = _ref2.isAccordion;
  return "\n    list-style-type: none;\n    margin: ".concat(theme.space.normal, " 0;\n    padding-left:  ").concat(isAccordion ? '0' : theme.space.semi, ";\n  ");
});

var OptionsList = _styledComponents.default.li.withConfig({
  displayName: "CheckboxCard__OptionsList",
  componentId: "sc-5qmi0b-2"
})(function (_ref3) {
  var theme = _ref3.theme;
  return "\n    display: flex;\n    align-items: start;\n    width: 100%;\n    justify-content: space-between;\n    padding: ".concat(theme.space.semiSmall, " 0;\n\n    &:not(:first-child){\n      border-top: 1px solid ").concat(theme.colors.greyLight, ";\n    }\n\n    & > div{\n      flex: 1;\n    }\n  ");
});

var ComponentWrapper = _styledComponents.default.div.withConfig({
  displayName: "CheckboxCard__ComponentWrapper",
  componentId: "sc-5qmi0b-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return "\n    margin-bottom: ".concat(theme.space.small, ";\n  ");
});

var FooterWrapper = _styledComponents.default.div.withConfig({
  displayName: "CheckboxCard__FooterWrapper",
  componentId: "sc-5qmi0b-4"
})(function (_ref5) {
  var theme = _ref5.theme;
  return "\n    background-color: ".concat(theme.backgroundColor.greyLighter, ";\n    margin: 0 -").concat(theme.space.XSmall, ";\n    padding: ").concat(theme.space.XSmall, " ").concat(theme.space.normal, ";\n  ");
});

var CheckboxHeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "CheckboxCard__CheckboxHeaderWrapper",
  componentId: "sc-5qmi0b-5"
})(["display:flex;justify-content:space-between;align-items:center;cursor:pointer;"]);

var CheckboxHeader = _styledComponents.default.div.withConfig({
  displayName: "CheckboxCard__CheckboxHeader",
  componentId: "sc-5qmi0b-6"
})([""]);

var CheckboxAction = _styledComponents.default.div.withConfig({
  displayName: "CheckboxCard__CheckboxAction",
  componentId: "sc-5qmi0b-7"
})(["display:flex;justify-content:flex-end;align-items:center;"]);

var CheckboxCard = function CheckboxCard(props) {
  var data = props.data,
      value = props.value,
      footerMessage = props.footerMessage,
      component = props.component,
      onChange = props.onChange,
      onExpand = props.onExpand,
      expand = props.expand,
      accessible = props.accessible,
      theme = props.theme,
      customProperties = props.customProperties,
      isAccordion = props.isAccordion;
  var label = data.label,
      options = data.options;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(expand),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showCheck = _useState4[0],
      setShowCheck = _useState4[1];

  var getDefaultSelectedValue = function getDefaultSelectedValue() {
    var _defaultValue$value;

    if (value || !data || !data.options || !data.options[0] || !data.options[0].value) {
      var isAvailable = data.options.find(function (option) {
        return option.value === value && !!option.disabled;
      });

      if (isAvailable) {
        return value;
      }
    }

    var defaultValue = data.options.find(function (option) {
      return !option.disabled;
    });
    return (_defaultValue$value = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) !== null && _defaultValue$value !== void 0 ? _defaultValue$value : null;
  };

  var _useState5 = (0, _react.useState)(getDefaultSelectedValue()),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedValue = _useState6[0],
      setSelectedValue = _useState6[1];

  (0, _react.useEffect)(function () {
    setExpanded(expand);
    setShowCheck(expand && selectedValue);
  }, [expand, selectedValue]);
  (0, _react.useEffect)(function () {
    var newSelectedValue = value !== null && value !== void 0 ? value : getDefaultSelectedValue();
    setSelectedValue(newSelectedValue);
    setShowCheck(expanded && newSelectedValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  var checkboxOnchangeHandler = function checkboxOnchangeHandler() {
    var newExpandedValue = !expanded;
    setExpanded(newExpandedValue);
    setShowCheck(newExpandedValue && selectedValue);

    if (selectedValue && onChange) {
      var isExisting = data.options.find(function (option) {
        return option.value === selectedValue;
      });
      var newValue = isExisting ? selectedValue : getDefaultSelectedValue();
      onChange(newExpandedValue ? newValue : null);
    }

    if (onExpand) {
      onExpand(newExpandedValue);
    }
  };

  var radioButtonOnChangeHandler = function radioButtonOnChangeHandler(val) {
    if (val !== selectedValue) {
      setSelectedValue(val);

      if (onChange) {
        onChange(val);
      }
    }
  };

  var renderTag = function renderTag(tag) {
    var tagLabel = tag.label,
        backgroundColor = tag.backgroundColor,
        textColor = tag.textColor;

    if (!tagLabel) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement(_Tag.default, {
      accessible: false,
      display: "inlineFlex",
      theme: theme,
      type: "small",
      backgroundColor: backgroundColor,
      color: textColor,
      customProperties: {
        margin: '0'
      },
      clickable: false
    }, tagLabel);
  };

  var renderFooter = function renderFooter() {
    return /*#__PURE__*/_react.default.createElement(FooterWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: "small",
      color: "greyDark",
      theme: theme
    }, footerMessage));
  };

  var removeWrapperPaddingBottom = function removeWrapperPaddingBottom() {
    return Boolean(expanded && (!component || footerMessage));
  };

  var renderCheckbox = function renderCheckbox() {
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      accessible: true,
      boldText: true,
      disableBottomMargin: true,
      disabledWithSelected: false,
      isFullWidth: false,
      isSelected: expanded,
      onChange: checkboxOnchangeHandler,
      text: label,
      theme: theme,
      textCustomProperties: {
        type: 'default'
      }
    });
  };

  var renderAccordion = function renderAccordion() {
    return /*#__PURE__*/_react.default.createElement(CheckboxHeaderWrapper, {
      onClick: checkboxOnchangeHandler
    }, /*#__PURE__*/_react.default.createElement(CheckboxHeader, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      boldText: true,
      color: "neutral",
      type: "default"
    }, label)), /*#__PURE__*/_react.default.createElement(CheckboxAction, null, showCheck && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: "secondary",
      fontsize: "titleNormal",
      icon: _constant.ICONS.CHECK_CIRCLE,
      theme: theme
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: "secondary",
      fontsize: "titleSmall",
      padding: "0 0 0 5px",
      icon: expanded ? _constant.ICONS.EXPAND_LESS : _constant.ICONS.EXPAND_MORE
    })));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_Container.default, (0, _extends2.default)({
      hasBorder: expanded,
      height: "auto",
      accessible: accessible,
      layout: 1
    }, customProperties), /*#__PURE__*/_react.default.createElement(CheckboxWrapper, {
      removePaddingButtom: removeWrapperPaddingBottom()
    }, isAccordion ? renderAccordion() : renderCheckbox(), expanded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(OptionsListWrapper, {
      isAccordion: isAccordion
    }, // eslint-disable-next-line react/prop-types
    options.map(function (val) {
      var optionsLabel = val.label,
          subLabel = val.subLabel,
          optionsValue = val.value,
          tag = val.tag,
          _val$disabled = val.disabled,
          disabled = _val$disabled === void 0 ? false : _val$disabled;
      return /*#__PURE__*/_react.default.createElement(OptionsList, {
        key: optionsValue
      }, /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
        accessible: true,
        boldText: true,
        color: "secondary",
        hideButton: false,
        isReversed: false,
        onChange: function onChange() {
          radioButtonOnChangeHandler(optionsValue);
        },
        selected: optionsValue === selectedValue,
        text: optionsLabel,
        textColor: "neutral",
        theme: theme,
        vertical: false,
        subText: subLabel,
        isFullWidth: true,
        disabled: disabled
      }), tag && renderTag(tag));
    })), component && /*#__PURE__*/_react.default.createElement(ComponentWrapper, null, component), footerMessage && renderFooter())));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

CheckboxCard.propTypes = _CheckboxCard.default.PropTypes;
CheckboxCard.defaultProps = _CheckboxCard.default.DefaultProps;
var _default = CheckboxCard;
exports.default = _default;